<template >
  <!-- <div v-if="viewMode" v-html="formatNumber(value)"></div> -->
  <div class="input-number-wrap" >
    <input
        ref="input"
        type="text"
        class="number-input"
        v-model="content"
        @keypress="filter"
        :disabled="disabled"
        :placeholder="placeholder"
        @change="$emit('change',verifiedGreek?content.replace(',', '.'):content)" />
    <!-- <el-input-number
            v-model="formDada.bookedPrice"
            :controls="false"
            :precision="2"
            :step="0.01"
    ></el-input-number>-->
  </div >
</template >

<script >
export default {
  name: "s-number",
  props: {
    autoformat: {default: true, type: Boolean},
    formatgreek: {default: true, type: Boolean},
    value: {default: null},
    digits: {default: 2},
    placeholder: {type: String, default: "_,_"},
    // decimalsSeperator: { type: String, default: "," },
    viewMode: {type: Boolean, default: false},
    disabled: {default: false, type: Boolean},
  },
  data() {
    return {
      initialValue: null,
      content: null,
    };
  },
  created() {
    if (this.verifiedGreek)
      this.content = this.value ? (this.value + "").replace(",", ".") : "";
    else this.content = this.value;
    this.initialValue = "" + this.content;
  },
  watch: {
    value(val, oldval) {
      _log_("snumber val w.CCC.", val);
      if (val === oldval) return;
      // _log_("val w..", this.grStrToNumber(val));
      if (!val) {
        this.content = "";
        return;
      }
      if (val && this.grStrToNumber(val) != this.grStrToNumber(this.content)) {
        if (this.verifiedGreek)
          this.content = this.value ? (this.value + "").replace(",", ".") : "";
        else this.content = this.value;
        if (this.content === null || this.content == "") {
          this.content = "";
          return;
        }
        //detect star writing digits
        // _log_(
        //   "vhann.l...",
        //   this.content.indexOf("."),
        //   this.content.length
        // );
        if (
            (this.content + "").length - (this.content + "").indexOf(".") !=
            1
        ) {
          this.content = parseFloat(this.content); //.toPrecision(this.digits);
          this.content = this.content.toFixed(this.digits);
          this.content = parseFloat(this.content);
          if (this.verifiedGreek)
            this.content = this.content
                ? (this.content + "").replace(".", ",")
                : "";
        }
        this.initialValue = "" + this.content;
      }
    },
    content: function (val, oldval) {
      _log_("snumber content w...", val, oldval);
      // if (!val && !oldval) return;
      if (val != oldval && val != this.value) {
        // val = this.content = this.content.replace(",", ".");
        // _log_("k.C." + this.content);
        this.$nextTick(() => {
          if (this.verifiedGreek) this.content = this.content.replace(".", ",");
          // this.content = parseFloat(this.content).toPrecision(this.digits);
        });
        if (val === null || val === '') this.$emit("input", null)
        else
          this.$emit("input", this.verifiedGreek ? val.replace(",", ".") : val);
        // this.$emit("change", { val: val, oldval: oldval });
      } //{val:val,oldval:oldval})
    },
  },
  computed: {
    verifiedGreek() {
      const c = this.content + "";
      // _log_("content w.verifiedGreek..", this.content);
      return c && c.indexOf(",") >= 0 && this.content.indexOf(".") < 0;
    },
    noFormatYet() {
      const c = this.content + "";
      return c.indexOf(",") < 0 && c.indexOf(".") < 0;
    },
  },
  methods: {
    filter(event) {
      // _log_("k.." + event.keyCode, this.verifiedGreek);
      if (event.keyCode == 13) {
        this.$emit(
            "input",
            this.verifiedGreek ? this.content.replace(",", ".") : this.content
        );
        return;
      }
      if (
          (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
          // event.keyCode != 46 &&
          ((this.verifiedGreek && event.keyCode != 44) ||
              (!this.verifiedGreek && event.keyCode != 46))
      ) {
        if (!this.noFormatYet) event.preventDefault();
        return;
      }
      if (event.keyCode == 44) {
        if (this.verifiedGreek && (this.content + "").indexOf(",") > -1) {
          if (!this.noFormatYet) event.preventDefault();
          return;
        }
      }
      if (event.keyCode == 46) {
        if (!this.verifiedGreek && (this.content + "").indexOf(".") > -1) {
          if (!this.noFormatYet) event.preventDefault();
          return;
        }
      }
      this.$emit("keypress", event);
    },
  },
};
</script >
<style >
.input-number-wrap {
  margin-left: 2px;
  margin-right: 2px;
  background-color: rgba(118, 228, 191, 0.185);
  /* box-shadow: 0px 1px 1px; */
}

.number-input {
  /* border-radius: 4px; */
  background-color: unset;
  border: none;
  text-align: right;
  width: 100%;
  border-bottom: 1px solid #409eff;
}
</style >

